import React, { useEffect, useState } from "react";
import {
  Modal,
  Text,
  Box,
  Table,
  createStyles,
  ActionIcon,
  Loader,
  Skeleton,
} from "@mantine/core";
import { useSelector } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import TableLoader from "../../../components/TableLoader";
import { decrypt } from "../../../utils";
// import TableLoader from "../../../components/TableLoader";
// import { getMar } from "../../../services";
// import defaultImage from "./../../../images/personal2.png";
// import { decrypt } from "../../../utils";
// import Cuations from "../Medication/Cuations";

const TaskViewReportModal = ({
  selectedClient,
  monthValue,
  opened,
  onClose,
}) => {
  const { classes } = useStyles();
  // const { tasks, loadingTasks } = useSelector((state) => state?.task);
  const { allTasks, loadingTasks } = useSelector((state) => state?.task);
  const [pdfLoading, setPDFLoading] = useState(false);
  const [taskItems, setTaskItems] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const { allSignature } = useSelector((state) => state?.signature);

  // date formating function
  const today = new Date();
  const formattedDate = `${
    today.getMonth() + 1
  }-${today.getDate()}-${today.getFullYear()}`;
  const reportName = `${formattedDate}_Task_Report`;

  const start = moment(monthValue?.[0]).clone().startOf("day");
  let end;
  if (
    moment(monthValue?.[0])?.format("MMM") ==
    moment(monthValue?.[monthValue?.length - 1])?.format("MMM")
  ) {
    end = moment(monthValue?.[monthValue?.length - 1])
      .add(1, "M")
      .clone()
      .startOf("day");
  } else {
    end = moment(monthValue?.[monthValue?.length - 1])
      .endOf("month")
      .clone()
      .startOf("day");
  }

  const datesArray = [];
  let currentDate = start;

  if (
    moment(monthValue?.[0])?.format("MMM") ==
    moment(monthValue?.[monthValue?.length - 1])?.format("MMM")
  ) {
    while (currentDate < end) {
      datesArray.push(currentDate.clone());
      currentDate.add(1, "day");
    }
  } else {
    while (currentDate <= end) {
      datesArray.push(currentDate.clone());
      currentDate.add(1, "day");
    }
  }

  const daysArray = datesArray.map((date) => date.format("ddd"));

  useEffect(() => {
    if (opened && allTasks) {
      // find client related tasks
      let filteredTasks = allTasks?.filter(
        (taskItem) => taskItem?.client?.id === selectedClient?.id
      );

      // sort tasks
      filteredTasks = filteredTasks.sort(
        (a, b) => new Date(a.dateTime) - new Date(b.dateTime)
      );
      const items = [];
      let staffs = [];
      filteredTasks?.flatMap((taskItem) => {
        return (
          taskItem.taskType?.subTasks?.map((subTask) => {
            const taskName = subTask?.task;

            const indexOfTaskTypeAndTask = items?.findIndex(
              (_i) =>
                _i?.taskTypeId === taskItem?.taskType?.id &&
                _i?.taskId === taskName?._id
            );

            let fields = [];

            subTask?.fields?.map((field) => {
              let isChecked = taskItem?.fieldsDone?.filter(
                (_fd) => _fd?.field?._id === field?._id
              )?.[0];
              // setStaffs(taskItem?.staff?.map((v) => v?.name))
              console.log(isChecked);
              staffs.push(
                isChecked?.staff?.name
                  ? {
                      name: isChecked?.staff?.name,
                      id: isChecked?.staff?.id,
                    }
                  : undefined
              );
              fields.push({
                id: field._id,
                name: field.name,
                isChecked: isChecked,
              });
            });

            let updated_fields = fields?.map((field) => {
              let tempTableData = [];

              datesArray?.map((date) => {
                let checkedDate;
                if (field?.isChecked?.checkedAt) {
                  checkedDate =
                    // moment(field?.isChecked?.checkedAt).format("YYYY-MM-DD") ==
                    moment(taskItem?.dateTime).format("YYYY-MM-DD") ==
                    moment(date).format("YYYY-MM-DD")
                      ? true
                      : false;

                  if (checkedDate) {
                    if (indexOfTaskTypeAndTask === -1) {
                      tempTableData.push({
                        isChecked: [field?.isChecked],
                        date: moment(date).format("MM-DD-YYYY"),
                        fieldName: field?.name,
                      });
                    } else {
                      let index_of_field = items[
                        indexOfTaskTypeAndTask
                      ]?.fields?.findIndex((_v) => _v?.id === field?.id);
                      if (index_of_field !== -1) {
                        let date_array_index = items[
                          indexOfTaskTypeAndTask
                        ]?.fields[index_of_field]?.date_array?.findIndex(
                          (_v) => _v?.date === moment(date).format("MM-DD-YYYY")
                        );

                        items[indexOfTaskTypeAndTask].fields[
                          index_of_field
                        ].date_array[date_array_index] = {
                          isChecked: [
                            ...items[indexOfTaskTypeAndTask]?.fields[
                              index_of_field
                            ]?.date_array[date_array_index]?.isChecked,
                            field?.isChecked,
                          ],
                          date: moment(date).format("MM-DD-YYYY"),
                          fieldName: field?.name,
                        };
                      }
                    }
                  } else {
                    if (indexOfTaskTypeAndTask === -1) {
                      tempTableData.push({
                        isChecked: [],
                        date: moment(date).format("MM-DD-YYYY"),
                        fieldName: field?.name,
                      });
                    }
                  }
                } else {
                  if (indexOfTaskTypeAndTask === -1) {
                    tempTableData.push({
                      isChecked: [],
                      date: moment(date).format("MM-DD-YYYY"),
                      fieldName: field?.name,
                    });
                  }
                }
              });

              return {
                ...field,
                date_array: tempTableData,
              };
            });

            if (indexOfTaskTypeAndTask === -1) {
              items.push({
                taskTypeId: taskItem.taskType?.id,
                taskId: taskName?._id,
                taskName: taskName?.name,
                fields: updated_fields,
                taskType: taskItem.taskType?.name,
              });
            } else {
              // let fieldIndex = items[index]?.fields?.findIndex(_v => _v?.id === )
            }
          }) || []
        );
      });
      setTaskItems(items);
      setStaffs([
        ...new Map(
          staffs.filter((_v) => _v).map((item) => [item.id, item])
        ).values(),
      ]);
    }
  }, [opened, allTasks]);

  const downloadPDF = async () => {
    setPDFLoading(true);
    const input = document.getElementById("taskPDFReport");
    await createPDF(input);
  };

  const createPDF = async (input) => {
    await html2canvas(input, {
      scale: 2,
      allowTaint: false,
      useCORS: true,
      onclone: (clonedDoc) => {
        const imgs = clonedDoc.querySelectorAll("img");
        imgs.forEach((img) => {
          img.style.display = "block";
        });
      },
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 320; // Width of the image in the PDF
      const pageHeight = 210; // Height of an A4 page in landscape mode in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      const pdf = new jsPDF("landscape", "mm", [310, 210]);

      // Add the first part of the image
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);

      heightLeft -= pageHeight;

      // Add additional pages if the content exceeds one page
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`${reportName}.pdf`);
      setPDFLoading(false);
    });
  };

  const getInitials = (name, id, isExcel = false) => {
    console.log("isexcel, ---", isExcel);
    const findSign = allSignature.find(
      (item) => (item?.staff && item?.staff === id) || (item?.admin && item?.admin === id)
    );
    if (decrypt(findSign?.signatureInitials) && !isExcel) {
      return (
        <img
          src={decrypt(findSign?.signatureInitials)}
          height={20}
          alt=""
          crossOrigin="anonymous"
          style={{
            display: "inline-block",
          }}
        />
      );
    } else if (findSign?.signatureInitialsText && !isExcel) {
      return (
        <Text fz={20} fw={400} ff="Island Moments" color="#171717">
          {findSign?.signatureInitialsText}
        </Text>
      );
    } else {
      return (
        <Text span fw={400}>
          {name
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase())
            .join("")}
        </Text>
      );
    }
  };

  return (
    <>
      <Modal
        centered
        size={1355}
        shadow="md"
        radius={"lg"}
        zIndex={1000}
        opened={opened}
        onClose={onClose}
        styles={{
          header: { width: "1340px" },
          padding: "0px",
          margin: "0px",
        }}
        overlayProps={{ blur: 3 }}
      >
        <>
          <Box className={classes.exportBtn}>
            <ActionIcon ml={15} disabled={loadingTasks} loading={loadingTasks}>
              <ReactHTMLTableToExcel
                table="excelTaskTable"
                loading={loadingTasks}
                disabled={loadingTasks}
                sheet={reportName}
                id="test-table-xls-button"
                filename={`${reportName}`}
                className="download-table-xls-button"
                buttonText={
                  <ActionIcon>
                    <img src="/assets/images/xlsDowload.png" alt="xls" />
                  </ActionIcon>
                }
              />
            </ActionIcon>

            <ActionIcon
              ml={15}
              loading={pdfLoading || loadingTasks}
              disabled={pdfLoading || loadingTasks}
              onClick={downloadPDF}
            >
              <img src="/assets/images/pdf.png" alt="pdf" />
            </ActionIcon>
          </Box>
          <TaskTableComponent
            loading={loadingTasks}
            monthValue={monthValue}
            daysArray={daysArray}
            datesArray={datesArray}
            selectedClient={selectedClient}
            data={taskItems}
            staffs={staffs}
            getInitials={getInitials}
          />
          <div style={{ display: "none" }}>
            <TaskTableComponent
              loading={loadingTasks}
              monthValue={monthValue}
              daysArray={daysArray}
              datesArray={datesArray}
              selectedClient={selectedClient}
              data={taskItems}
              staffs={staffs}
              getInitials={getInitials}
              isExcel={true}
            />
          </div>
        </>
      </Modal>

      <PDFTaskTableComponent
        loading={loadingTasks}
        daysArray={daysArray}
        datesArray={datesArray}
        monthValue={monthValue}
        selectedClient={selectedClient}
        data={taskItems}
        staffs={staffs}
        getInitials={getInitials}
      />
    </>
  );
};

const SignatureImage = ({ url }) => {
  const [base64, setBase64] = useState(null);

  useEffect(() => {
    if (!url) return;

    const urlToBase64 = async (url) => {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };

    urlToBase64(url).then(setBase64).catch(console.error);
  }, [url]);

  if (!base64) return <Skeleton height={60} width={100} />;

  return (
    <img
      src={base64}
      alt="signature"
      width={200}
      style={{ display: "block" }}
    />
  );
};

const CommonTableHeader = ({
  staffs,
  selectedClient,
  monthValue,
  getInitials,
  isExcel,
  taskType,
}) => {
  const { classes } = useStyles();
  const { allSignature } = useSelector((state) => state?.signature);

  return (
    <tbody style={{ display: isExcel ? "none" : "" }}>
      <tr>
        <td></td>
        {staffs
          ?.filter((_v) => _v && _v.id)
          ?.map(({ id }, index) => {
            return (
              <React.Fragment key={index}>
                <td
                  className={classes.bgCellColor}
                  style={{ background: "#b7b7b7" }}
                >
                  <Text fw={700} w={"100px"}>
                    Staff Name
                  </Text>
                </td>
                <td
                  className={classes.bgCellColor}
                  style={{ background: "#b7b7b7" }}
                >
                  <Text fw={700} w={"100px"}>
                    Initial
                  </Text>
                </td>
                <td
                  className={classes.bgCellColor}
                  style={{ background: "#b7b7b7" }}
                >
                  <Text fw={700} w={"100px"}>
                    Signature
                  </Text>
                </td>
              </React.Fragment>
            );
          })}
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        {staffs
          ?.filter((_v) => _v && _v.id)
          ?.map(({ name, id }) => {
            const staffSignature = allSignature?.find(
              ({ staff, admin }) => (staff && staff === id) || (admin && admin === id)
            );
            return (
              <>
                <td>
                  <Text fw={400}>{name}</Text>
                </td>
                <td>{getInitials(name, id)}</td>
                <td>
                  {staffSignature?.signature ||
                  staffSignature?.signatureImage ? (
                    isExcel ? (
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={
                            decrypt(staffSignature?.signature) ||
                            decrypt(staffSignature?.signatureImage)
                          }
                          width="50"
                          height="50"
                          style={{
                            display: "block",
                            objectFit: "cover",
                          }}
                          alt="logo"
                          crossOrigin="anonymous"
                        />
                      </div>
                    ) : (
                      <SignatureImage
                        url={
                          decrypt(staffSignature?.signature) ||
                          decrypt(staffSignature?.signatureImage)
                        }
                      />
                    )
                  ) : staffSignature?.signatureText ? (
                    <Text fz={28} fw={400} ff="Island Moments" color="#171717">
                      {staffSignature?.signatureText}
                    </Text>
                  ) : (
                    "none"
                  )}
                </td>
              </>
            );
          })}
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700} w={"100px"}>
            Resident Name
          </Text>
        </td>
        <td>
          <Text>{selectedClient?.name}</Text>
        </td>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700} w={"100px"}>
            Sex
          </Text>
        </td>
        <td>
          <Text w={"100px"}>{selectedClient?.form1?.gender}</Text>
        </td>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700} w={"100px"}>
            DOB
          </Text>
        </td>
        <td>{moment(selectedClient?.form1?.dob).format("DD/MM/YYYY")}</td>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700} w={"100px"}>
            Today's Date
          </Text>
        </td>
      </tr>
      <tr>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700}>Allergies</Text>
        </td>
        <td>
          {selectedClient?.form1?.knownAllergies
            ?.map((item) => item)
            .join(", ") || "None"}
        </td>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700}>Admission Date</Text>
        </td>
        <td>
          {moment(selectedClient?.form1?.admissionDate).format("DD/MM/YYYY")}
        </td>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700} w={"100px"}>
            Current Month
          </Text>
        </td>
        <td>{new Date().toLocaleString("default", { month: "long" })}</td>
        <td>{moment().format("MM/DD/YYYY")}</td>
      </tr>
      <tr>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700}>Report Month</Text>
        </td>
        <td>
          {monthValue
            ?.map((item) =>
              moment(item).isValid() ? moment(item).format("MMM YYYY") : ""
            )
            .join(" - ")}
        </td>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}><Text fw={700}>Task Type</Text></td>
        <td>{taskType}</td>
        <td className={classes.bgCellColor} style={{ background: "#b7b7b7" }}>
          <Text fw={700}>Current Year</Text>
        </td>
        <td>{new Date().getFullYear()}</td>
        <td></td>
      </tr>
    </tbody>
  );
};

const TaskTableComponent = ({
  data,
  loading,
  daysArray,
  datesArray,
  monthValue,
  selectedClient,
  staffs,
  getInitials,
  isExcel = false,
}) => {
  console.log("🚀 ~ TaskTableComponent ~ data:", data)
  const { classes } = useStyles();
  return (
    <Box className={classes.tableContainer}>
      {loading ? (
        <Box className={classes.loaderContainer}>
          <TableLoader />
        </Box>
      ) : (
        <>
          <Box className={classes.tableHeader}>
            <Box className={classes.clientDetails}>
              <Box className={classes.clientInfo}>
                <Table withBorder withColumnBorders style={{ width: "1270px" }}>
                  <CommonTableHeader
                    staffs={staffs}
                    selectedClient={selectedClient}
                    monthValue={monthValue}
                    getInitials={getInitials}
                    taskType={data[0]?.taskType}
                  />
                </Table>
              </Box>
            </Box>
          </Box>
          <Box className={classes.tableBody}>
            <Table
              id={isExcel ? "excelTaskTable" : "taskTable"}
              withColumnBorders
            >
              {/* this thead content only show on excel sheet not on modal */}
              <CommonTableHeader
                staffs={staffs}
                selectedClient={selectedClient}
                monthValue={monthValue}
                getInitials={getInitials}
                isExcel={true}
                taskType={data[0]?.taskType}
              />

              <tbody>
                <tr
                  className={classes.dateCells}
                  style={{ background: "#d0e0e3" }}
                >
                  <td className={classes.dateCellsContent}></td>
                  <td className={classes.dateCellsContent}></td>
                  {daysArray?.map((day, index) => (
                    <td key={index} className={classes.dateCellsContent}>
                      <Text>{day}</Text>
                    </td>
                  ))}
                </tr>
                <tr
                  className={classes.dateCells}
                  style={{ background: "#d0e0e3" }}
                >
                  <td className={classes.dateCellsContent}></td>
                  <td className={classes.dateCellsContent}></td>
                  {datesArray?.map((date, index) => (
                    <td key={index} className={classes.dateCellsContent}>
                      <Text>{date?.format("MM/DD/YYYY")}</Text>
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Item</td>
                  <td>Task</td>
                  {datesArray?.map((date, index) => (
                    <td key={index}>
                      <Text>{date.format("DD")}</Text>
                    </td>
                  ))}
                  {/* {marTableData[0]?.data?.map((v, zerothIndexs) => (
                    <td>{zerothIndexs + 1}</td>
                  ))} */}
                </tr>

                {data?.map((_task, i) => (
                  <>
                    {_task?.fields?.map((_field, index) => {
                      return (
                        <tr key={index}>
                          {index === 0 && (
                            <td
                              rowSpan={index === 0 ? _task?.fields?.length : 0}
                              style={{ border: "1px solid #ccc" }}
                            >
                              {_task?.taskName || "-"}
                            </td>
                          )}
                          <td>{_field?.name || "-"}</td>
                          {datesArray?.map((date, dIndex) => {
                            const found = _field?.date_array?.find((x) => {
                              return (
                                moment(x?.date).format("YYYY-MM-DD") ===
                                date.format("YYYY-MM-DD")
                              );
                            });
                            return (
                              <td
                                key={dIndex}
                                style={{
                                  padding:
                                    found?.isChecked?.length > 0
                                      ? "0"
                                      : "intial",
                                }}
                              >
                                {found?.date && found?.fieldName == _field?.name
                                  ? found?.isChecked?.map((_fc, index) => (
                                      <Text
                                        style={{
                                          borderBottom:
                                            index ===
                                              found?.isChecked?.length - 1 ||
                                            !found?.isChecked?.length > 1
                                              ? "none"
                                              : "1px solid #ccc",
                                          padding: 5,
                                        }}
                                      >
                                        {getInitials(
                                          _fc?.staff?.name,
                                          _fc?.staff?.id,
                                          isExcel
                                        )}
                                        {`${" "}${"-"} ${_fc?.textField}`}
                                      </Text>
                                    ))
                                  : ""}{" "}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </>
                ))}
              </tbody>
            </Table>
          </Box>
        </>
      )}
    </Box>
  );
};

const PDFTaskTableComponent = ({
  data,
  loading,
  daysArray,
  datesArray,
  selectedClient,
  monthValue,
  staffs,
  getInitials,
}) => {
  const { classes } = useStyles();

  const ref_months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let startMonth = ref_months?.findIndex(
    (item) =>
      item?.toLowerCase() == moment(monthValue[0])?.format("MMM")?.toLowerCase()
  );
  let endMonth = ref_months?.findIndex(
    (item) =>
      item?.toLowerCase() ==
      moment(monthValue[monthValue?.length - 1])
        ?.format("MMM")
        ?.toLowerCase()
  );

  let filteredMonths = ref_months?.slice(startMonth, endMonth + 1);

  return (
    <Box className={classes.forPdfBox} id={"taskPDFReport"}>
      {loading ? (
        <Box className={classes.loaderContainer}>
          <TableLoader />
        </Box>
      ) : (
        <>
          {/* Table Header */}
          <Box
            className={classes.tableHeader}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box className={classes.clientDetails}>
              <Box className={classes.clientInfo}>
                <Table
                  withBorder
                  withColumnBorders
                  borderColor="red"
                  style={{ width: "1650px" }}
                >
                  <CommonTableHeader
                    staffs={staffs}
                    selectedClient={selectedClient}
                    monthValue={monthValue}
                    getInitials={getInitials}
                    taskType={data[0]?.taskType}
                  />
                </Table>
              </Box>
            </Box>
          </Box>
          {filteredMonths?.map((month, monthIndex) => (
            <Box key={monthIndex} mb={30}>
              <Box className={classes.reportMonth}>
                <Text fw={700}>Report Month: </Text>
                <Text fz={20} fw={500} align="center">
                  {month}
                </Text>
              </Box>

              {/* Table Body */}
              <Box className={classes.tableBody}>
                <Table id={`taskTable-${monthIndex}`} withColumnBorders>
                  <thead>
                    <tr
                      className={classes.dateCells}
                      style={{ background: "#d0e0e3" }}
                    >
                      <td className={classes.dateCellsContent}></td>
                      <td className={classes.dateCellsContent}></td>
                      {/* {daysArray?.map((day, index) => (
                        <td key={index} className={classes.dateCellsContent}>
                          <Text>{day}</Text>
                        </td>
                      ))} */}
                      {datesArray
                        ?.filter(
                          (item) =>
                            moment(item)?.format("MMM")?.toLowerCase() ==
                            month?.toLowerCase()
                        )
                        ?.map((date, index) => (
                          <td key={index} className={classes.dateCellsContent}>
                            <Text>{date.format("ddd")}</Text>{" "}
                          </td>
                        ))}
                    </tr>
                    <tr
                      className={classes.dateCells}
                      style={{ background: "#d0e0e3" }}
                    >
                      <td className={classes.dateCellsContent}></td>
                      <td className={classes.dateCellsContent}></td>
                      {datesArray
                        ?.filter(
                          (item) =>
                            moment(item)?.format("MMM")?.toLowerCase() ==
                            month?.toLowerCase()
                        )
                        ?.map((date, index) => (
                          <td key={index} className={classes.dateCellsContent}>
                            <Text>{date.format("MM/DD/YYYY")}</Text>
                          </td>
                        ))}
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Item</td>
                      <td>Task</td>
                      {datesArray
                        ?.filter(
                          (item) =>
                            moment(item)?.format("MMM")?.toLowerCase() ==
                            month?.toLowerCase()
                        )
                        ?.map((date, index) => (
                          <td key={index} className={classes.dateCellsContent}>
                            <Text>{index + 1}</Text>
                          </td>
                        ))}
                    </tr>

                    {data?.map((_task, i) => (
                      <>
                        {_task?.fields?.map((_field, index) => {
                          return (
                            <tr key={index}>
                              {index === 0 && (
                                <td
                                  rowSpan={
                                    index === 0 ? _task?.fields?.length : 0
                                  }
                                  style={{ border: "1px solid #ccc" }}
                                >
                                  {_task?.taskName || "-"}
                                </td>
                              )}
                              <td>{_field?.name || "-"}</td>
                              {datesArray
                                ?.filter(
                                  (item) =>
                                    moment(item)
                                      ?.format("MMM")
                                      ?.toLowerCase() == month?.toLowerCase()
                                )
                                ?.map((date, dIndex) => {
                                  const found = _field?.date_array?.find(
                                    (x) => {
                                      return (
                                        moment(x?.date).format("YYYY-MM-DD") ===
                                        date.format("YYYY-MM-DD")
                                      );
                                    }
                                  );
                                  return (
                                    <td
                                      key={dIndex}
                                      style={{
                                        padding:
                                          found?.isChecked?.length > 0
                                            ? "0"
                                            : "intial",
                                      }}
                                    >
                                      {found?.date &&
                                      found?.fieldName == _field?.name
                                        ? found?.isChecked?.map(
                                            (_fc, index) => (
                                              <Text
                                                style={{
                                                  borderBottom:
                                                    index ===
                                                      found?.isChecked?.length -
                                                        1 ||
                                                    !found?.isChecked?.length >
                                                      1
                                                      ? "none"
                                                      : "1px solid #ccc",
                                                  padding: 5,
                                                }}
                                              >
                                                {getInitials(
                                                  _fc?.staff?.name,
                                                  _fc?.staff?.id
                                                )}
                                                {`${" "}${"-"} ${
                                                  _fc?.textField
                                                }`}
                                              </Text>
                                            )
                                          )
                                        : ""}{" "}
                                    </td>
                                  );
                                })}
                            </tr>
                          );
                        })}
                      </>
                    ))}
                  </tbody>
                </Table>
              </Box>
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

const useStyles = createStyles((theme) => ({
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "70vh",
  },
  reportMonth: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
  },
  greenBox: {
    width: "15px",
    height: "15px",
    background: "#4fa80d",
  },
  exportBtn: {
    display: "flex",
    justifyContent: "end",
    padding: "1rem",
    alignItems: "center",
    gap: "1rem",
    width: "1320px",
  },
  tableContainer: {
    border: "1px solid #EDEDED",
    width: "1320px",
  },
  forPdfBox: {
    width: "1920px",
    position: "absolute",
    left: "-9999px",
  },
  clientDetails: {
    display: "flex",
    alignItems: "start",
    gap: ".5rem",
    justifyContent: "start",
    padding: "1rem",
  },
  cuationsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: ".5rem",
    flexDirection: "column",
  },
  tableBodyBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: ".5rem",
    width: "100%",
  },
  bgCellColor: {
    background: "#b7b7b7",
  },
  dateCells: {
    backgroundColor: "#d0e0e3",
    border: "unset",
  },
  bgTitleColor: {
    background: "#ffff00",
    width: "200px",
  },
  medTitleCell: {
    width: "200px",
  },
  tableHeader: {
    width: "100%",
  },
  tableBody: {
    overflowX: "scroll",
    "& table": {
      width: "500px",
      "& tr:nth-child(1) td": {
        fontSize: "12px !important",
        fontWeight: "400 !important",
        textAlign: "center",
      },
      "& tr:nth-child(2) td": {
        fontSize: "10px !important",
        fontWeight: "300 !important",
        textAlign: "center",
      },
    },
  },
  dateCellsContent: {
    borderTop: "none !important",
    borderRight: "none !important",
  },
}));

export default TaskViewReportModal;
